import { useEffect, useState } from 'react';

export const useKlarnaWidgetPriceMutationObserver = (initialPrice: number | undefined) => {
  const [monetatePriceFound, setMonetatePriceFound] = useState(false);
  const [dataPurchaseAmount, setDataPurchaseAmount] = useState(initialPrice);

  useEffect(() => {
    // Select the node that will be observed for mutations
    const targetNode = document.getElementById('pdp-sticky-container');

    // Options for the observer (which mutations to observe)
    const config = { childList: true };

    // mutation Callback function to execute when mutations are observed
    const callback: MutationCallback = (mutationList) => {
      mutationList.forEach((mutation) => {
        if (mutation.type !== 'childList') return;
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          const elementNode = node as Element;
          const priceNode = elementNode?.querySelector('.mt-discount__promo-code')?.textContent;
          if (!elementNode.matches('.mt-discount-wrap') || !priceNode) return;
          const priceNumber = parseFloat(priceNode.replace(/[^0-9]/g, ''));
          setMonetatePriceFound(true);
          setDataPurchaseAmount(priceNumber);
        });
      });
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    if (targetNode && !monetatePriceFound) {
      observer.observe(targetNode, config);
    }
    // set a timer that will disconnect the observer past 20 seconds
    setTimeout(() => {
      observer.disconnect();
    }, 20000);
  }, [monetatePriceFound]);

  return { dataPurchaseAmount };
};
